module.exports = function (p18335) {
  var v14077;
  var vA795 = [];
  for (var v14078 = p18335.length, vLN02598 = 0; vLN02598 < v14078; vLN02598++) {
    v14077 = p18335.charCodeAt(vLN02598);
    if (v14077 >= 55296 && v14077 <= 56319 && v14078 > vLN02598 + 1) {
      var v14079 = p18335.charCodeAt(vLN02598 + 1);
      if (v14079 >= 56320 && v14079 <= 57343) {
        v14077 = (v14077 - 55296) * 1024 + v14079 - 56320 + 65536;
        vLN02598 += 1;
      }
    }
    if (v14077 < 128) {
      vA795.push(v14077);
      continue;
    }
    if (v14077 < 2048) {
      vA795.push(v14077 >> 6 | 192);
      vA795.push(v14077 & 63 | 128);
      continue;
    }
    if (v14077 < 55296 || v14077 >= 57344 && v14077 < 65536) {
      vA795.push(v14077 >> 12 | 224);
      vA795.push(v14077 >> 6 & 63 | 128);
      vA795.push(v14077 & 63 | 128);
      continue;
    }
    if (v14077 >= 65536 && v14077 <= 1114111) {
      vA795.push(v14077 >> 18 | 240);
      vA795.push(v14077 >> 12 & 63 | 128);
      vA795.push(v14077 >> 6 & 63 | 128);
      vA795.push(v14077 & 63 | 128);
      continue;
    }
    vA795.push(239, 191, 189);
  }
  return new Uint8Array(vA795).buffer;
};